// 部门
import request from "@/utils/interceptor.js";

const department = {
  getList(params) {
    if (!params) {
      params = {
        SkipCount: 0,
        MaxResultCount: 1000,
      };
    }
    return request({ url: "/api/pas/department", method: "get", params });
  },
};
// 部门列表
export function getDepartment(params) {
  return request({
    url: "/api/pas/department",
    method: "get",
    params,
  });
}
// 添加部门
export function postDepartment(data) {
  return request({
    url: "/api/pas/department",
    method: "post",
    data,
  });
}
// 编辑部门
export function putDepartment(data) {
  return request({
    url: `/api/pas/department/${data.id}`,
    method: "put",
    data,
  });
}
// 删除部门
export function deleteDepartment(id) {
  return request({
    url: `/api/pas/department/${id}`,
    method: "delete",
  });
}
export default department;
